module.exports = __webpack_public_path__ + "img/video_menu_video_share.e339e3d4.svg";